import { underscore } from 'HELPERS/text';
import mixpanelbrowser from 'mixpanel-browser';

export default class Mixpanel{
  constructor(){
    this.instance = null;
    this.group = null;
  }

  track(event, params = {}) {
    this.instance.track(`${underscore(event)}`, { ...params, app: 'STP' });
  }
  
  track_time_event(event){
    this.instance.track_time_event(event);
  }

  optOutTracking(trackBoo) {
   if (!this.instance) return;
   
   this.instance.set_config({ opt_out_tracking_by_default: trackBoo });

   if (trackBoo) {
     this.instance.opt_out_tracking();
   }
  }
}

